var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhysicalEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.09,124.17C116,64.72,215.15,73.11,253.41,114.92s50.7,68.6,85.21,53,78.52-11.44,81,38.16S381.75,314.33,317.57,331.68s-64.16,78.76-149.1,66.37c-46.31-6.76-47.36-56.86-40.82-98.3S55.71,193.12,88.09,124.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09,124.17C116,64.72,215.15,73.11,253.41,114.92s50.7,68.6,85.21,53,78.52-11.44,81,38.16S381.75,314.33,317.57,331.68s-64.16,78.76-149.1,66.37c-46.31-6.76-47.36-56.86-40.82-98.3S55.71,193.12,88.09,124.17Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.91,388.42s-5.53-12.06.78-24,8.15-14.69,4.13-17.13-5.88,9.52-5.88,9.52-3.39-8.22-.59-16.83,4.56-22.61.73-24.11-.73,17.48-4.05,23.95a55.83,55.83,0,0,1-3.25-14.12c-.46-6.91.26-17.94-2.76-20.77s-5-.87-2,14.38A159.66,159.66,0,0,1,389,347s-6.56-20-11-20.59-4.39,5.9-.62,11.52,11,15.68,12.22,20.86c0,0-7.2-15-13.67-10.44s5.63,13.71,11,17,9.15,23.88,9.15,23.88Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.91,388.42s-5.53-12.06.78-24,8.15-14.69,4.13-17.13-5.88,9.52-5.88,9.52-3.39-8.22-.59-16.83,4.56-22.61.73-24.11-.73,17.48-4.05,23.95a55.83,55.83,0,0,1-3.25-14.12c-.46-6.91.26-17.94-2.76-20.77s-5-.87-2,14.38A159.66,159.66,0,0,1,389,347s-6.56-20-11-20.59-4.39,5.9-.62,11.52,11,15.68,12.22,20.86c0,0-7.2-15-13.67-10.44s5.63,13.71,11,17,9.15,23.88,9.15,23.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.54,393.37s5.39-12.15-1.07-23.95-8.33-14.57-4.33-17.06,6,9.42,6,9.42,3.29-8.27.39-16.83-4.83-22.54-1-24.1.94,17.46,4.33,23.89a55.6,55.6,0,0,0,3.08-14.17c.38-6.91-.47-17.93,2.52-20.81s4.95-.94,2.16,14.35A159.49,159.49,0,0,0,404,351.79s6.32-20.1,10.72-20.74,4.47,5.82.77,11.5-10.85,15.85-12,21c0,0,7-15.16,13.55-10.64s-5.47,13.79-10.83,17.15-8.87,24-8.87,24Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.54,393.37s5.39-12.15-1.07-23.95-8.33-14.57-4.33-17.06,6,9.42,6,9.42,3.29-8.27.39-16.83-4.83-22.54-1-24.1.94,17.46,4.33,23.89a55.6,55.6,0,0,0,3.08-14.17c.38-6.91-.47-17.93,2.52-20.81s4.95-.94,2.16,14.35A159.49,159.49,0,0,0,404,351.79s6.32-20.1,10.72-20.74,4.47,5.82.77,11.5-10.85,15.85-12,21c0,0,7-15.16,13.55-10.64s-5.47,13.79-10.83,17.15-8.87,24-8.87,24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.37 384.71 374.9 384.71 378.5 416.53 415.77 416.53 419.37 384.71",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.11,150.61s1.71,12.43-1.92,19.45c0,0,8.53,2.68,23.71.27S295,163.09,295,163.09l-4.41-13.6s3.15-13.32-10.83-16.09S244.92,140.1,256.11,150.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.52,181.82c1.8,1.41,3.52,2.9,5.27,4.36s3.46,3,5.16,4.49,3.4,3,5.08,4.6,3.32,3.09,5.1,4.89l-.29-.26,1,.89.79.79c.53.52,1,1,1.48,1.55l2.81,3.07c1.85,2.05,3.63,4.13,5.42,6.21s3.53,4.2,5.25,6.34,3.43,4.28,5.08,6.49a2.77,2.77,0,0,1-4,3.79h0c-2.11-1.75-4.16-3.56-6.23-5.34l-6.11-5.45-6-5.48-3-2.69-1.47-1.3-.7-.6-.59-.47-.29-.25c-1.55-1.3-3.39-2.74-5.12-4.14l-5.28-4.24c-1.76-1.42-3.51-2.87-5.25-4.32s-3.49-2.9-5.18-4.4h0a5.56,5.56,0,0,1,7.13-8.52Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.55,235.84l-2.73-.23a3.21,3.21,0,0,1-2.47-1.56l-2.44-4.14a6,6,0,0,1-.31-5.44l.49-1.09c4.55.08,9.41,3.52,9.41,3.52l1.49.83a2.65,2.65,0,0,1,1.12,3.6l-1.6,3A3,3,0,0,1,354.55,235.84Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.28,313.66c-.71,1.29-7.59-2.26-8.48-3.59,1.52-25.23-6.33-43.38,0-56-7.06,12.29-19.64,21.14-28.6,26.26a101.32,101.32,0,0,1-9.39,4.77h0l-1,.42,1.82-23.14c-5.39.45-10.48-.71-12.93-3.86-6.47-8.31-3.11-32.08,28.64-29.69a29.14,29.14,0,0,1,1.59,4.54c14.48-7.45,34.67-15.12,41.22-4.2C366.49,246.5,343.28,313.66,343.28,313.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.84,176.31c6.81-3.33,12.69-.46,22.08,8.48-.18,5-7.87,13.17-7.87,13.17S291.63,185.63,292.84,176.31Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.84,176.31c6.81-3.33,12.69-.46,22.08,8.48-.18,5-7.87,13.17-7.87,13.17S291.63,185.63,292.84,176.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,187.72A110.48,110.48,0,0,1,311,202.49c.86,7.25,1.48,14.41,2.31,26.39l-36.25,5.74c-.89-10.33-3.92-21.78-14.07-43.73a8.57,8.57,0,0,1,5.49-12.14c1.41-.37,2.92-.73,4.47-1.05a117,117,0,0,1,16.46-2.61c1.82-.12,3.71-.19,5.52-.22C301.48,174.74,307.4,181.36,308.6,187.72Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,187.72A110.48,110.48,0,0,1,311,202.49c.86,7.25,1.48,14.41,2.31,26.39l-36.25,5.74c-.89-10.33-3.92-21.78-14.07-43.73a8.57,8.57,0,0,1,5.49-12.14c1.41-.37,2.92-.73,4.47-1.05a117,117,0,0,1,16.46-2.61c1.82-.12,3.71-.19,5.52-.22C301.48,174.74,307.4,181.36,308.6,187.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.46,180.91c-11.7-4.9-16.6-3.36-16.6-3.36a6.88,6.88,0,0,0,1.1-3.66c.29-4.63-2-11-3.78-14.91l11.54,2.83c0,.59,0,1.17,0,1.73.22,6.23,1.85,11,7.57,11.41C290.33,175,292.84,176,290.46,180.91Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,163.54c-.9,3.36-3,8.66-7.8,10.35.29-4.63-2-11-3.78-14.91l11.54,2.83C282.72,162.4,282.73,163,282.76,163.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.41,313.72c-4.38,28.43-4.93,74.06-3.84,92.65-1.59.93-7.37.28-10.5-.7,0,0-18.88-61-5-89.15-9-65.79,4-81.9,4-81.9l2.48-.39,2.1-.33,22.19-3.52S296.57,286.64,292.41,313.72Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,402.29l-1.95.45c-11.6-49.9-2.9-81.13-2-84.21-5.75-33.31.39-71.89,2.7-84.3l2.1-.33c-2.18,11.49-8.67,50.8-2.79,84.53l0,.24-.07.24C278.72,319.22,268.75,350.55,280.78,402.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,416.53c-6.8,0-7.7-.11-11.52-.24-3.27-.11-4.05.3-6.68.24-2.2,0-2.12-2.15-1.44-4.57.34-1.22.86-3.78,1.33-5.75l10-.72c1.4,2.68,4.56,6.49,8.4,7C300.33,413,299.34,416.53,296.63,416.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,335.93a69.3,69.3,0,0,1-10-12.2c-1.85-2.64-2.21-2-4.18-4.58-1.31-1.72-.11-4.17,1.78-4.71a28.59,28.59,0,0,0,5.08-1.51l6.79,5c-1.24,3.2.4,12.22,3.89,15.92C348.31,336.51,344.45,337.74,342.48,335.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,179.93c-3.43,1.06-3.69,6.53-3.69,6.53s-9.37-4.62-12.71-8.4a35.49,35.49,0,0,0,2.77-2.45S285.64,178.23,288,179.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,178.84s3.16.34,4.94,4.43c-.42-7.85-4.24-8.6-4.24-8.6a4.52,4.52,0,0,0-3.24.05A3.79,3.79,0,0,1,291.25,178.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37,148c.9,8.77,1.47,12.45-2.09,17.83-5.35,8.11-16.08,7.84-19.53-.35-3.1-7.37-4.05-20.46,3.69-25.74A11.29,11.29,0,0,1,283.37,148Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,152.54c.11.73-.18,1.4-.64,1.51s-.92-.42-1-1.15.18-1.41.64-1.51S273.07,151.81,273.18,152.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.17,154.21c.11.74-.18,1.41-.64,1.51s-.92-.41-1-1.14.18-1.41.64-1.51S264.06,153.48,264.17,154.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.35,153.07l-1.76-.14S262.66,154.11,263.35,153.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,155.23a21.75,21.75,0,0,1-1.82,5.22,2.92,2.92,0,0,0,2.57-.06Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,162.22a7.18,7.18,0,0,1-1.16.36.2.2,0,0,1-.24-.17.24.24,0,0,1,.18-.26,6.14,6.14,0,0,0,4.21-3.26.2.2,0,0,1,.27-.12.21.21,0,0,1,.11.28A6.49,6.49,0,0,1,272.33,162.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,154.52a7,7,0,0,1-3.54,4.07c-2.17,1-3.58-1-3.25-3.48.3-2.19,1.78-5.36,4.09-5.35S288.12,152.27,287.35,154.52Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.83,147.66a.42.42,0,0,1-.33,0,3.14,3.14,0,0,0-3-.23.42.42,0,0,1-.56-.19.46.46,0,0,1,.22-.59,3.93,3.93,0,0,1,3.78.25.45.45,0,0,1-.12.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.79,150.19a.37.37,0,0,1-.31,0,.43.43,0,0,1-.22-.56,4.51,4.51,0,0,1,2.86-2.81.38.38,0,0,1,.48.32.46.46,0,0,1-.33.53,3.62,3.62,0,0,0-2.24,2.25A.45.45,0,0,1,259.79,150.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,151.39l-1.76-.14S271.66,152.44,272.36,151.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.61,141.51s9.17,8.42,15.55,8.71l2.58,4.19,3-4.42s2.31-10.17-1.37-13-15.44-1.46-15.44-1.46a20,20,0,0,0-14.64,4.84c-6.54,5.86,5.57,15.59,5.57,15.59S257.07,148.87,264.61,141.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,190.6c2.14,2.22,4.35,4.54,6.58,6.76s4.43,4.5,6.7,6.66,4.55,4.3,6.86,6.33a84.63,84.63,0,0,0,7,5.6l-.61-.33c2.78,1.34,5.86,2.6,8.93,3.81s6.21,2.41,9.36,3.56l18.94,7a2.77,2.77,0,0,1-1.43,5.32h0c-3.38-.58-6.7-1.28-10-2s-6.64-1.52-9.95-2.35-6.62-1.74-9.92-2.75-6.6-2-10-3.45a3.54,3.54,0,0,1-.39-.19l-.23-.14a76.82,76.82,0,0,1-8.45-5.94c-2.65-2.07-5.14-4.24-7.58-6.46s-4.83-4.46-7.15-6.78-4.58-4.63-6.81-7.13a5.56,5.56,0,0,1,8.13-7.59Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.37,310.66c-.56,1.76-1.54,4.9-2.22,7.25-.23.77-.74,1.28-1.17,1.17-3.23-.83-7.73-4.13-9.19-5.24a1.44,1.44,0,0,1-.26-1.4l1.46-6.6c.2-.9.82-1.54,1.29-1.33l9.8,4.48C345.48,309.18,345.61,309.91,345.37,310.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.37,310.66c-.56,1.76-1.54,4.9-2.22,7.25-.23.77-.74,1.28-1.17,1.17-3.23-.83-7.73-4.13-9.19-5.24a1.44,1.44,0,0,1-.26-1.4l1.46-6.6c.2-.9.82-1.54,1.29-1.33l9.8,4.48C345.48,309.18,345.61,309.91,345.37,310.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,398.5c.2,1.66.58,4.54,1.08,6.73a1.48,1.48,0,0,1-.6,1.74c-4.24,1.5-10.67.56-12.71.2a1.28,1.28,0,0,1-.85-1.09l-1.27-6.27c-.17-.86.19-1.68.76-1.72l12.57-.86C288.45,397.2,288.9,397.75,289,398.5Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,398.5c.2,1.66.58,4.54,1.08,6.73a1.48,1.48,0,0,1-.6,1.74c-4.24,1.5-10.67.56-12.71.2a1.28,1.28,0,0,1-.85-1.09l-1.27-6.27c-.17-.86.19-1.68.76-1.72l12.57-.86C288.45,397.2,288.9,397.75,289,398.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,186.69c-2.61,7.11.85,12.66,10.71,21.09,4.95-.69,12.29-9.19,12.29-9.19S273.74,184.52,264.59,186.69Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,186.69c-2.61,7.11.85,12.66,10.71,21.09,4.95-.69,12.29-9.19,12.29-9.19S273.74,184.52,264.59,186.69Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,280.37a101.32,101.32,0,0,1-9.39,4.77,49.93,49.93,0,0,1,9.9-18.66A84.92,84.92,0,0,1,306.18,280.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.35,229.13l7.84-2,8.35,2.85-1.27,8-6.56-1.51a14.34,14.34,0,0,1-10.5-2.18Z",
    style: {
      fill: "#ce7a63"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.91,286.27c1.13,2.85,2.33,5.75,3.59,8.52a42.79,42.79,0,0,0,1.93,3.84l.2.31c.05.09.1.14,0,.06-.29-.22,0,0,.05,0s.26.19.4.29c.59.41,1.26.85,1.9,1.28,5.22,3.42,10.56,6.81,15.87,10.17l-2.47,4.29c-5.59-2.94-11.16-5.86-16.75-8.92-.7-.39-1.39-.77-2.13-1.2-.18-.11-.35-.2-.59-.36a4.58,4.58,0,0,1-.9-.66,9.79,9.79,0,0,1-.77-.82c-.19-.24-.34-.44-.49-.65a49.45,49.45,0,0,1-2.7-4.39c-1.59-2.86-3-5.68-4.47-8.58Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.64,278.84c-6.47-.77-3.67,11.93,7,21.61l8.17-6.4S219.3,280.21,207.64,278.84Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.77,294.05,216,299.34l-1.41,1.11a43.16,43.16,0,0,1-3.48-3.58c-7.69-8.95-9.17-18.71-3.48-18C219.3,280.21,222.77,294.05,222.77,294.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,299.34l-1.41,1.11a43.16,43.16,0,0,1-3.48-3.58c.76-5.17,1.84-10.25,1.84-10.25A15.22,15.22,0,0,1,216,299.34Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,287.54A89.34,89.34,0,0,0,213.57,299a155.5,155.5,0,0,0-.14,16.24c0,.76,0,1.18,0,1.18L176,318.56c.27-4.86.84-9.73,1.54-14.34.45-3,1-5.87,1.49-8.56.23-1.12.45-2.21.67-3.25.38-1.8.76-3.49,1.11-5,1.38-5.92,2.53-9.71,2.53-9.71s5.9-2.09,17.71-.21a40.72,40.72,0,0,1,10.17,2.81A6.6,6.6,0,0,1,214.94,287.54Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,287.54A89.12,89.12,0,0,0,213.56,299a161.26,161.26,0,0,0-.14,16.23c0,.77.06,1.19.06,1.19L176,318.57c.27-4.87.83-9.74,1.54-14.35.29-2,.62-3.91,1-5.77.17-.95.35-1.88.53-2.79l.15-.73c.09-.47.19-.95.28-1.41s.16-.75.24-1.11.13-.63.2-.94c.24-1.14.48-2.22.72-3.25.06-.29.13-.57.19-.84.57-2.44,1.11-4.53,1.53-6.13.6-2.27,1-3.58,1-3.58s5.91-2.09,17.72-.21a40.85,40.85,0,0,1,10.17,2.81A6.6,6.6,0,0,1,214.94,287.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.19,281.45l3.22-.88,7.18,6.05,4.58-5.6,3.39,1.84a13.71,13.71,0,0,0-12.3-7.89C186.2,274.87,189.19,281.45,189.19,281.45Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,273.3a5.79,5.79,0,0,0-.76,5.5,6.36,6.36,0,0,0,1,1.68l-4,5.06-9-7.16a7.15,7.15,0,0,0,1-1.16c1.23-1.76,2.93-5.49.82-10.81l8.54,3.53,3.88,1.6A8.87,8.87,0,0,0,203.36,273.3Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,271.54a8.87,8.87,0,0,0-1.5,1.76c-3.45,2.75-8.85,3.64-11.74,3.92,1.23-1.76,2.93-5.49.82-10.81l8.54,3.53Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39,243.83s-10.34,6.44-1.07,16.12C199.8,270.88,190.39,243.83,190.39,243.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,259.52c-1.47,7.13-6.58,14.56-12.69,14.85-11.21.53-15.22-2.13-15.35-10.42-.16-7.46,4-18.68,13.3-19.62S213.36,249.63,211.32,259.52Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.67,248.48a20.13,20.13,0,0,0,10.53,2s7.39,4.16,5.78,9,.67,5.37,0,11.92c0,0,6.92.08,9.86-14.09,2.15-10.32-6.37-15.56-15.69-16.6C191.38,239.86,185.15,244.74,188.67,248.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.61,259.42c-.16.91-.77,1.57-1.37,1.46s-.94-.93-.79-1.84.77-1.56,1.37-1.46S194.76,258.51,194.61,259.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.39,257.81c-.15.87-.73,1.5-1.31,1.39s-.9-.88-.75-1.75.73-1.5,1.31-1.4S187.54,256.94,187.39,257.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,254.4a.44.44,0,0,1-.11-.24.42.42,0,0,1,.41-.42,4.09,4.09,0,0,1,3.44,1.61.42.42,0,0,1-.11.58h0a.44.44,0,0,1-.58-.11h0a3.25,3.25,0,0,0-2.76-1.23A.42.42,0,0,1,192.78,254.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.65,253.55a.39.39,0,0,1,0-.72,4.1,4.1,0,0,1,3.79-.23.42.42,0,0,1,.17.57h0a.43.43,0,0,1-.56.17h0a3.25,3.25,0,0,0-3,.24A.43.43,0,0,1,185.65,253.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,259.11l.29,4a4.91,4.91,0,0,1-2.87-.65A11.8,11.8,0,0,0,188.63,259.11Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28,266.24a23,23,0,0,1,1.39,3.05c.2,0,.39-.07.58-.12,2.62-.55,3.66-1.67,4-2.74a3.42,3.42,0,0,0,.09-1.63,3.07,3.07,0,0,0-.27-.9,12.56,12.56,0,0,1-4.91,2.14C188.63,266.18,188.28,266.24,188.28,266.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,266l.43.89c2.47-.53,4.13-1.22,4.75-2.13a3.07,3.07,0,0,0-.27-.9A12.56,12.56,0,0,1,189.17,266Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,269.17c2.62-.55,3.66-1.67,4-2.74a8.52,8.52,0,0,0-2.79,1.18A3.29,3.29,0,0,0,190.25,269.17Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,243.38s-3.4,2.74.67,8.47l3.11.17-.36-1.33,4,3.4,2.8,1.64-1.66-3.57s4.07,4,3.51,7.81l3.08,1.81.39-1.22s.93,5.63,2.52,8.57,6-6,6-6-1.41-11-10-16.08S189.09,243.38,189.09,243.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.63,262.81s2.56-4.13,4.63-2.4.52,9-2.87,8.52S200.74,265,202.63,262.81Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.15,249.29s4.49-10.32,12.26-7.09,1.78,22,1.78,22l-1.25-4.36s-2.07,8.14-3.54,8.36c0,0,2.75-11.8,1.37-14.56s-5.32,1.23-5.32,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,311.08s.22,3.85,1,5.18a14.13,14.13,0,0,0,2.62,2.87l1.95,3.42,6.31-4.5L244,312.3l-5.11-4Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.39,351.1l-3.88-5.52,3.33-17.73A33.12,33.12,0,0,1,207,342.09a32.31,32.31,0,0,1-8,1.13c-.35,15.49-7.1,67.32-7.1,67.32l-4.77-.41-1-.09-.24,0c-6.67-39.38-1.88-40-6.62-61.57s-2.64-37.33-2.64-37.33l2.08,0,1,0,33.28.61.52,4.58s19.42-20.78,27.53-5.25C245.59,319.87,227.39,351.1,227.39,351.1Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.72,351.52a8.27,8.27,0,0,1-1.17-1.34.14.14,0,0,1,0-.17.18.18,0,0,1,.15-.08c.25,0,2.51.3,2.91,1.07a.61.61,0,0,1,0,.57.8.8,0,0,1-.71.52A1.77,1.77,0,0,1,229.72,351.52Zm1.59-.35c-.22-.41-1.41-.72-2.31-.86.74,1,1.42,1.5,1.85,1.48a.59.59,0,0,0,.45-.34.31.31,0,0,0,0-.28Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.18,350.29a8.79,8.79,0,0,1-1.77.18.14.14,0,0,1-.14-.09.15.15,0,0,1,0-.17c.17-.19,1.7-1.87,2.56-1.75a.59.59,0,0,1,.45.34.84.84,0,0,1,0,.89A1.8,1.8,0,0,1,230.18,350.29Zm.64-1.5c-.46-.06-1.41.73-2,1.39,1.21-.05,2-.29,2.28-.66a.59.59,0,0,0,0-.56.3.3,0,0,0-.22-.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7,349.12l-5.6-4.89a.47.47,0,0,0-.66,0h0l-4.15,4.19a1.18,1.18,0,0,0,.1,1.64c2,1.68,3,2.38,5.49,4.51a61.54,61.54,0,0,0,6.73,5.55c2.36,1.47,3.75-.89,2.89-1.73a18.18,18.18,0,0,1-4.19-8.25A1.87,1.87,0,0,0,228.7,349.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,342.09a32.31,32.31,0,0,1-8,1.13l6.48-7.21A26.2,26.2,0,0,1,207,342.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,410.13l-1-.09c-3.92-29.12-3-49.06-3-50.67-4.3-12.11-4.52-38.36-4.44-48.21l1,0c-.08,9.83.14,36,4.42,47.95l0,.09v.11C184.11,359.57,183,379.91,187.12,410.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,410.82a8.17,8.17,0,0,1-1.76-.28.13.13,0,0,1-.11-.12.14.14,0,0,1,.06-.15c.21-.15,2.12-1.38,2.93-1a.59.59,0,0,1,.34.45.82.82,0,0,1-.21.85A1.73,1.73,0,0,1,195.2,410.82Zm1-1.29c-.43-.17-1.55.35-2.33.83,1.18.26,2,.24,2.37-.06a.55.55,0,0,0,.12-.55.28.28,0,0,0-.16-.22Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77,409.58a8.41,8.41,0,0,1-1.25,1.28.14.14,0,0,1-.16,0,.18.18,0,0,1-.1-.14c0-.26.11-2.53.85-3a.56.56,0,0,1,.56,0,.85.85,0,0,1,.58.67A1.81,1.81,0,0,1,194.77,409.58ZM194.3,408c-.4.24-.61,1.46-.68,2.36.89-.8,1.38-1.52,1.33-2a.58.58,0,0,0-.38-.41.24.24,0,0,0-.27,0Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,409.57l-7.1-.1a.66.66,0,0,0-.61.42h0l-2.21,5.53a.77.77,0,0,0,.73,1.11c2.49,0,3.72-.12,6.86-.1a62.43,62.43,0,0,0,8.42-.13c2.76-.37,3.13-2.92,2-3a12.47,12.47,0,0,1-7.11-3.36A1.36,1.36,0,0,0,192.55,409.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,310.06s3.86,0,5.23.67a14,14,0,0,1,3,2.45l3.53,1.74-4.13,6.57-5.88-2.18-3.72-4.26Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.76,296.13l-6.2,5c-4.53,1.61-8.79-5.36-11.69-9.67.24-1.14.48-2.22.72-3.25.06-.29.13-.57.19-.84.57-2.44,1.11-4.53,1.53-6.13,3.87.38,8.63,3.55,11.23,5.91C199.21,292.31,197.76,296.13,197.76,296.13Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,289.8c1.13,2.84,2.33,5.74,3.58,8.49.63,1.36,1.3,2.77,1.93,3.84a3.23,3.23,0,0,0,.19.3l.07.13a.32.32,0,0,0-.1-.1c-.13-.06-.1,0-.09,0s0,0,0,0l.21.11.42.22.5.23,1,.46c2.78,1.23,5.7,2.39,8.61,3.54s5.84,2.28,8.76,3.39l-1.56,4.7c-3-.88-6.06-1.77-9.08-2.69s-6-1.85-9.11-2.92l-1.17-.42-.6-.22-.65-.27-.32-.14c-.1,0-.32-.16-.48-.25a4.67,4.67,0,0,1-1-.72l-.52-.52-.28-.34c-.16-.21-.38-.47-.5-.65-1.09-1.56-1.87-2.95-2.69-4.38-1.59-2.85-3-5.66-4.45-8.57Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,277.62c-6.11-2.27-6.38,10.72,1.66,22.65l9.46-4.3S197,281.7,186,277.62Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,277.62c-6.11-2.27-6.38,10.72,1.66,22.65l9.46-4.3S197,281.7,186,277.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.19,308.33s2.34,3.06,3.71,3.73a13.65,13.65,0,0,0,3.78.91l3.53,1.73,2.69-7.27-5.31-3.34-6.45-.4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19,308.33s2.34,3.06,3.71,3.73a13.65,13.65,0,0,0,3.78.91l3.53,1.73,2.69-7.27-5.31-3.34-6.45-.4Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,290.43c.85.88,1.79,1.81,2.69,2.66s1.87,1.7,2.62,2.26c.17.13.33.24.29.24s.08,0,.15.08l.23.1.46.21,1.83.83,3.66,1.67,11.57,6.09-2.6,4.54-11.63-3.91-3.81-1.28-1.91-.64-.47-.16-.24-.08a2.47,2.47,0,0,1-.31-.12,12.32,12.32,0,0,1-1.48-.71,39.06,39.06,0,0,1-3.8-2.55c-1.16-.86-2.23-1.69-3.36-2.62Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,290.43c.85.88,1.79,1.81,2.69,2.66s1.87,1.7,2.62,2.26c.17.13.33.24.29.24s.08,0,.15.08l.23.1.46.21,1.83.83,3.66,1.67,11.57,6.09-2.6,4.54-11.63-3.91-3.81-1.28-1.91-.64-.47-.16-.24-.08a2.47,2.47,0,0,1-.31-.12,12.32,12.32,0,0,1-1.48-.71,39.06,39.06,0,0,1-3.8-2.55c-1.16-.86-2.23-1.69-3.36-2.62Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,282.23c9,1.57,17.68,10.48,17.68,10.48L131,301.29l-10.09-5.8Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,292.71,131,301.29l-2.07-1.19-6.24-3.59-1.78-1L119,282.23C128,283.8,136.64,292.71,136.64,292.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.9,300.1l-6.24-3.59a9.13,9.13,0,0,1,.39-5.91S128.15,294.3,128.9,300.1Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.12,301.68c-2.06,2.25-4.13,4.6-6.05,6.92-.94,1.15-1.91,2.37-2.58,3.36a2.62,2.62,0,0,0-.17.28l-.08.11a.66.66,0,0,0,.06-.2.86.86,0,0,1,0-.19s0-.07,0,0v.23l0,.46v.54l0,1.1c.11,3,.35,6.17.59,9.28s.51,6.24.79,9.36l-5.56.77c-.57-3.11-1.13-6.21-1.66-9.33s-1-6.23-1.48-9.47l-.14-1.25-.07-.63-.05-.72,0-.36c0-.11,0-.38,0-.57a4.78,4.78,0,0,1,.2-1.34c.08-.26.16-.51.25-.76l.19-.41c.12-.26.26-.58.37-.77.93-1.72,1.83-3,2.75-4.42,1.85-2.71,3.72-5.25,5.68-7.84Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.69,332.88s1.72,3.45,1.72,5a13.82,13.82,0,0,1-.86,3.79v3.93l-7.71-.79-.66-6.24,2.17-5.22Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,288.08a89.56,89.56,0,0,0,2,11.31A158,158,0,0,0,131.35,315l.4,1.12L96.54,329.18c-1.17-4.73-2.06-9.55-2.74-14.16-.45-3-.8-5.9-1.09-8.62-.11-1.14-.22-2.25-.31-3.31-.17-1.83-.3-3.56-.42-5.13-.41-6.07-.44-10-.44-10s5-3.73,16.88-5.4a40.85,40.85,0,0,1,10.54-.3A6.59,6.59,0,0,1,124.68,288.08Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75,316.07,96.54,329.18c-1.17-4.73-2.06-9.55-2.74-14.16-.3-2-.55-3.93-.77-5.8-.12-1-.22-1.9-.32-2.82-.07-.74-.14-1.47-.21-2.18,0-.38-.07-.76-.1-1.13-.17-1.83-.3-3.56-.42-5.13-.41-6.07-.44-10-.44-10s5-3.73,16.88-5.4a40.85,40.85,0,0,1,10.54-.3,6.59,6.59,0,0,1,5.72,5.85,89.56,89.56,0,0,0,2,11.31A158,158,0,0,0,131.35,315Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1,355.28c3.75,16.74,2.2,58.57,2.2,58.57l5-1.36s7-40.53,5.21-64.11Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,289.82,101.1,288l8.64,3.67,2.74-6.69,3.77.76a13.69,13.69,0,0,0-14.07-3.93C93.49,284.41,98.28,289.82,98.28,289.82Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,278.72a5.39,5.39,0,0,0,1.43,3.92,4.65,4.65,0,0,0,.55.53,8.66,8.66,0,0,0,1,.69h0a22.15,22.15,0,0,1-3.4,4.69,42.15,42.15,0,0,1-5.54-1.16A19.63,19.63,0,0,1,98.82,286s1.69-3.2-.35-7.77a13.83,13.83,0,0,0-2.4-3.6l9.23.29,4.2.13A8.76,8.76,0,0,0,108.52,278.72Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,278.72a5.39,5.39,0,0,0,1.43,3.92,4.65,4.65,0,0,0,.55.53c-4.91.74-9.53-2.65-12-4.94a13.83,13.83,0,0,0-2.4-3.6l9.23.29,4.2.13A8.76,8.76,0,0,0,108.52,278.72Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.35,249.41s11.13,5,3.27,15.82C100.75,277.5,106.35,249.41,106.35,249.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.77,267.82c2.44,6.87,8.52,13.53,14.61,13,11.18-1,14.78-4.21,13.78-12.43-.87-7.41-6.49-18-15.87-17.62S84.4,258.31,87.77,267.82Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,253.78a20.1,20.1,0,0,1-10.15,3.47s-4.07,1.86-1.82,6.41-2.6,8.68-1.07,15.09c0,0-6.84,1-11.7-12.6-3.54-9.94,4.18-16.29,13.26-18.6C104.83,245.62,111.67,249.59,108.7,253.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32,265.43c.27.88,1,1.46,1.55,1.26s.81-1.05.53-1.92-1-1.44-1.55-1.27S104,264.55,104.32,265.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.24,262.85c.27.84.94,1.39,1.49,1.2s.77-1,.51-1.84-.94-1.38-1.49-1.21S111,262,111.24,262.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,261.89a.44.44,0,0,0,0,.25.41.41,0,0,0,.51.3,4.09,4.09,0,0,0,2.87-2.49.42.42,0,0,0-.27-.53h0a.44.44,0,0,0-.52.27h0a3.27,3.27,0,0,1-2.33,1.94A.47.47,0,0,0,102,261.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,257.7a.41.41,0,0,0-.21.15.42.42,0,0,0,.16.57,4.1,4.1,0,0,0,3.79.23.43.43,0,0,0,.18-.56h0a.44.44,0,0,0-.56-.18h0a3.27,3.27,0,0,1-3-.24A.41.41,0,0,0,108.62,257.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,264.61l1.29,3.82a5,5,0,0,0,2.4-1.7A11.87,11.87,0,0,1,109.76,264.61Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.83,269.9s-3.1-3.75-4.91-1.75.73,9,4,8.05S99,271.76,96.83,269.9Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,252s19.23-4.48,20.94-10.15c0,0,5.83,10.35-3.13,13.64S88,252,88,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.47,271.08l-.34,1.78s-.43.17-1,.36c-1.59.51-4.46,1.22-4.24-.36a5.36,5.36,0,0,1,.23-1,3.74,3.74,0,0,1,.36-.75c1.1-1.67,3.28-.89,4.37-.35A5.1,5.1,0,0,1,111.47,271.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,270.72l-.34.69-4-.34C107.54,269.4,109.72,270.18,110.81,270.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.09,273.22c-1.59.51-4.46,1.22-4.24-.36a5.36,5.36,0,0,1,.23-1C107.48,271.78,109.46,272,110.09,273.22Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,328.25s-.4.6-1.21,1.62a56.18,56.18,0,0,1-8.68,8.68c-5.74,4.65-9.47,4.29-9.47,4.29l-.91,14.58-.06,1h-.06c-1,.11-15.76,1.59-18.31-1.23l-1.78,2.49-.32-2-2.22-13.81c-3.74-14.64-2.94-23.41-2.94-23.41l1.56-.51,1.61-.53,31.55-10.32,1.5,3.4L134,310.6l2.23-1.38S140.75,310.9,140.66,328.25Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,410.82a8.16,8.16,0,0,1-1.77-.28.14.14,0,0,1-.11-.12.16.16,0,0,1,.06-.15c.22-.15,2.12-1.38,2.93-1a.6.6,0,0,1,.35.45.82.82,0,0,1-.21.85A1.74,1.74,0,0,1,114.2,410.82Zm1-1.29c-.43-.17-1.54.35-2.32.83,1.18.26,2,.24,2.37-.06a.57.57,0,0,0,.12-.55.29.29,0,0,0-.17-.22Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,409.58a8,8,0,0,1-1.25,1.28.14.14,0,0,1-.16,0,.17.17,0,0,1-.09-.14c0-.26.11-2.53.84-3a.58.58,0,0,1,.57,0,.86.86,0,0,1,.58.67A1.77,1.77,0,0,1,113.76,409.58Zm-.47-1.55c-.39.24-.61,1.46-.68,2.36.9-.8,1.39-1.52,1.33-2a.55.55,0,0,0-.37-.41.26.26,0,0,0-.28,0Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.55,409.57l-7.11-.1a.67.67,0,0,0-.61.42h0l-2.22,5.53a.78.78,0,0,0,.74,1.11c2.49,0,3.72-.12,6.85-.1a62.42,62.42,0,0,0,8.42-.13c2.76-.37,3.14-2.92,2-3a12.41,12.41,0,0,1-7.11-3.36A1.39,1.39,0,0,0,111.55,409.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,309.22c-.12-1-.22-1.9-.32-2.82-.07-.74-.14-1.47-.21-2.18A7.41,7.41,0,0,0,94,299.29S95.08,305.63,93,309.22Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,290.17c-1.17-6.41-12.48,0-18.61,13l8.52,5.93S99.08,301.72,97,290.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,290.17c-1.17-6.41-12.48,0-18.61,13l8.52,5.93S99.08,301.72,97,290.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39,357.42l-.06,1h-.06c-1,.11-15.76,1.59-18.31-1.23l-1.78,2.49-.32-2,.65-2.28S96.57,336,96.26,320l1.61-.53c.25,11,2.36,30.83,4.71,35.38C104.6,358.73,115.8,357.93,120.39,357.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,328.25s-.4.6-1.21,1.62c-2-1.28-5.74-4.28-6.6-9A18.84,18.84,0,0,1,134,310.6l2.23-1.38S140.75,310.9,140.66,328.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,311.6s7.33-8.62,16.43-8.42,6.79,19.8-6.7,44.52l-3.59-2.39s3.46-20,4.7-23.53a24.36,24.36,0,0,0,1.37-5.73l-8.25,11.37S131.16,321,135.31,311.6Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.93,352.65a8.2,8.2,0,0,1-.77-1.61.15.15,0,0,1,0-.16.16.16,0,0,1,.17,0c.24.09,2.33,1,2.52,1.82a.58.58,0,0,1-.18.54.83.83,0,0,1-.82.31A1.82,1.82,0,0,1,146.93,352.65Zm1.62.09c-.09-.46-1.16-1.08-2-1.45.45,1.12,1,1.82,1.39,1.92a.56.56,0,0,0,.52-.21.27.27,0,0,0,.08-.26Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.7,351.59a8,8,0,0,1-1.75-.31.15.15,0,0,1-.12-.12.2.2,0,0,1,.07-.16c.22-.14,2.15-1.34,2.94-1a.55.55,0,0,1,.34.45.82.82,0,0,1-.22.85A1.76,1.76,0,0,1,147.7,351.59Zm1-1.27c-.43-.19-1.55.32-2.34.78,1.18.28,2.05.28,2.37,0a.59.59,0,0,0,.14-.55.3.3,0,0,0-.17-.22Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,350.06l-4.07-6.22a.46.46,0,0,0-.64-.16h0l-5.12,2.91a1.17,1.17,0,0,0-.35,1.61c1.45,2.15,2.25,3.1,4.06,5.83a61.41,61.41,0,0,0,5,7.15c1.87,2.06,3.85.16,3.24-.88a18.21,18.21,0,0,1-1.8-9.07A1.94,1.94,0,0,0,146.59,350.06Z",
    style: {
      fill: "#263238"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalEducation);
export default __webpack_public_path__ + "static/media/physicalEducation.5241377505b800049c522d33c45cde86.svg";
export { ForwardRef as ReactComponent };